import { render, staticRenderFns } from "./IrisTableLoadingOverlay.vue?vue&type=template&id=da9bdc38&"
import script from "./IrisTableLoadingOverlay.vue?vue&type=script&lang=ts&"
export * from "./IrisTableLoadingOverlay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports